import React from "react";
import { Button } from "antd";
import { exportExcel } from "./excelexport";
import {
  calculare_medii,
  calculeaza_medie_materie,
} from "../utils/calculare_medie";
import { useSelector } from "react-redux";

function ExportMedii({
  classData,
  eleviData,
  gradesElevi,
  scutiri,
  permision,
}) {
  const materii = useSelector((state) => state.materii);
  const exportMediiToExcel = () => {
    if (!eleviData || !gradesElevi || !classData) {
      console.error("Date incomplete pentru export");
      return;
    }

    const worksheetData = [];

    // Header row - numele elevului + toate materiile + media generală
    const headerRow = [
      "Elev",
      ...classData.materii.map(
        (materie) => materii?.find((m) => m.id == materie.materie).numeMaterie
      ),
      "Media Generală",
    ];
    worksheetData.push(headerRow);

    // Data rows pentru fiecare elev
    eleviData
      .sort((a, b) => a?.nume?.localeCompare(b.nume, "ro"))
      .forEach((elev) => {
        const elevNotes = gradesElevi[elev.id]?.note || [];
        const elevScutiri = scutiri[elev.id] || [];

        const row = [elev.nume];

        // Calculează media pentru fiecare materie

        classData.materii.forEach((materie) => {
          const medieMaterie = calculeaza_medie_materie(
            elevNotes,
            materii?.find((m) => m.id === materie.materie),
            elevScutiri
          );

          // Afișează media sau mesaj dacă nu există note
          if (medieMaterie) {
            console.log("intru", medieMaterie, medieMaterie.inchidere_medie);
            row.push(medieMaterie.medie);
          } else {
            row.push("Medie deschisa");
          }
        });

        // Calculează media generală

        // console.log(elevNotes, classData.materii, elevScutiri);
        const medieGenerala = calculare_medii(elevNotes, materii, elevScutiri);
        console.log(calculare_medii(elevNotes, materii, elevScutiri));
        if (medieGenerala) {
          row.push(medieGenerala);
        } else {
        }
        console.log({ row });

        worksheetData.push(row);
      });

    // Exportă în Excel
    exportExcel(
      worksheetData,
      `${classData.anClasa}${classData.identificator} - Medii Elevi`
    );
  };

  if (permision !== true) {
    return null;
  }

  return (
    <Button
      type="primary"
      onClick={exportMediiToExcel}
      style={{ marginLeft: 8 }}
    >
      Export Medii
    </Button>
  );
}

export default ExportMedii;
